//deps
import styled from "styled-components";

// icons
import { RoundCloseIcon } from "@swiggy-private/core-ui";

const tooltipCloseIconHeight = 16;
const arrowDimensions = 12;

export const TurboPayCommsTooltipV2 = styled.div.attrs(
    (props: { isChangeModeAnimation: boolean; isTurboV2?: boolean }) => props,
)`
    position: absolute;
    right: ${props => (props.isChangeModeAnimation ? props.theme.spacing.medium : "")};
    bottom: ${props => {
        if (props.isChangeModeAnimation) {
            return "84px";
        }
        return "68px";
    }};
    transform: translateY(-120%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${props => props.theme.spacing.small};
    background-color: ${props => props.theme.colors[props.theme.colorMode].background_inverse_Primary};
    border-radius: ${props => props.theme.cornerRadius.medium};
    width: ${props => {
        if (props.isChangeModeAnimation) {
            return "200px";
        }
        return "256px";
    }};
    z-index: 1;

    ${props =>
        props.isTurboV2 &&
        `
        transform: translateY(-100%);
        left: ${props.theme.spacing.medium};
        right: 0;
        bottom: auto;
    `}

    &:before {
        //arrow
        content: "";
        width: ${arrowDimensions}px;
        height: ${arrowDimensions}px;
        background-color: ${props => props.theme.colors[props.theme.colorMode].background_inverse_Primary};
        position: absolute;
        bottom: 0px;
        right: ${props => (props.isChangeModeAnimation ? "21px" : "")};
        transform: translateY(47%) rotate(-45deg);
        border-radius: 0 0 0 2px;
        clip-path: polygon(0% 0%, 100% 100%, 0% 100%);

        ${props =>
            props.isTurboV2 &&
            `
            left: 21px;
            right: 0;
        `}
    }
`;

export const TooltipV2CloseIcon = styled(RoundCloseIcon)`
    background-color: transparent;
    height: ${tooltipCloseIconHeight}px;
    margin-left: 2px;
    align-self: baseline;
`;

export const LightningContainer = styled.div`
    display: flex;
`;
